module.exports = __webpack_public_path__ + "img/icon_ship_control.915760ab.png";